import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VisualModule} from '../material/visual.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LegendaComponent} from './legenda/legenda.component';
import {PlacaComponent} from './placa/placa.component';
import {StateCircleComponent} from './state-circle/state-circle.component';
import {CardRotaComponent} from './card-rota/card-rota.component';
import {IconeRotaComponent} from './icone-rota/icone-rota.component';
import {DetalhesRotaComponent} from './detalhes-rota/detalhes-rota.component';
import {ProgressCircleComponent} from './progress-circle/progress-circle.component';
import {TimelineComponent} from './timeline/timeline.component';
import {ResumoRotaComponent} from './resumo-rota/resumo-rota.component';
import {HistoricoRotaComponent} from './historico-rota/historico-rota.component';
import {CardRotaExpansivelComponent} from './card-rota-expansivel/card-rota-expansivel.component';
import {CancelarRotaComponent} from './cancelar-rota/cancelar-rota.component';
import {CardStatusIndicadoresComponent} from './card-status-indicadores/card-status-indicadores.component';
import {DoubleSliderComponent} from './double-slider/double-slider.component';
import {CardResumoComponent} from './card-resumo/card-resumo.component';
import { RotaDetalhesDialogComponent } from './rota-detalhes-dialog/rota-detalhes-dialog.component';
import {LogoAppComponent} from './logo-app/logo-app.component';
import {RotaDetalhesResumoComponent} from './rota-detalhes-resumo/rota-detalhes-resumo.component';
import { RotaDetalhesRelatorioComponent } from './rota-detalhes-relatorio/rota-detalhes-relatorio.component';
import { RelatoriDinamicoPdfComponent } from '~shared/components/relatorio-dinamico-dpf/relatorio-dinamico-pdf.component';
import { RelatoriDinamicoXlsComponent } from './relatorio-dinamico-xls/relatorio-dinamico-xls.component';
import {RotaDetalhesDocumentosComponent} from './rota-detalhes-documentos/rota-detalhes-documentos.component';
import { ResumoRotaDialogComponent } from './resumo-rota/resumo-rota-dialog.component';
import { RelatoriDinamicoXlsDialogComponent } from './relatorio-dinamico-xls/relatorio-dinamico-xls-dialog.component';
import {CancelaVisitaComponent} from './cancela-visita/cancela-visita.component';
import { EditServiceComponent } from './edit-service/edit-service.component';
import { DialogEditServiceComponent } from './edit-service/dialog-edit-service/dialog-edit-service.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ToolbarFiltroComponent} from './toolbar-filtro/toolbar-filtro.component';
import {ToolbarFiltroItemComponent} from './toolbar-filtro-item/toolbar-filtro-item.component';
import {CustomTimePickerComponent} from './custom-time-picker/custom-time-picker.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CabecalhoRotaComponent} from './cabecalho-rota/cabecalho-rota.component';
import {BotaoObservableComponent} from './botao-observable/botao-observable.component';
import {TituloBreadcrumbComponent} from './titulo-breadcrumb/titulo-breadcrumb.component';
import {TabelaServicosComponent} from './tabela-servicos/tabela-servicos.component';
import {RotaCorDialogComponent} from './rota-cor-dialog/rota-cor-dialog.component';
import {TranslateModule} from '@ngx-translate/core';
import {PieChartComponent} from './pie-chart/pie-chart.component';
import {NgChartsModule} from 'ng2-charts';
import {ChatComponent} from './chat/chat.component';
import {ChatRoomListComponent} from './chat-room-list/chat-room-list.component';
import {DialogCancelarComponent} from './cancela-visita/dialog-cancelar/dialog-cancelar.component';
import {LegendaMaxWidthDirective} from './legenda/directives/legenda-max-width.directive';
import {RotaDetalhesRecibosComponent} from '~shared/components/rota-detalhes-recibos/rota-detalhes-recibos.component';
import {TableCrudHeaderComponent} from './table-crud/table-crud-header/table-crud-header.component';
import {TableCrudDialogComponent} from './table-crud/table-crud-dialog/table-crud-dialog.component';
import { ModalServicosComponent } from './modal-servicos/modal-servicos.component';
import { MatTableModule } from '@angular/material/table';
import { HistoricoRegistrosComponent } from './historico-registros/historico-registros.component';
import { MatChipsModule } from '@angular/material/chips';
import {PipesModule} from '../pipes/pipes.module';
import { NotificationComponent } from './notification/notification.component';
import { CardVisitMapComponent } from './card-visit-map/card-visit-map.component';
import { DetalhesTimelineMapComponent } from './detalhes-timeline-map/detalhes-timeline-map.component';
import { TimelineVerticalComponent } from './timeline-vertical/timeline-vertical.component';
import { VisitaDetalhesDrawerComponent } from './visita-detalhes-drawer/visita-detalhes-drawer.component';
import { GaugeComponent } from './gauge/gauge.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { LucideAngularModule } from 'lucide-angular';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    LegendaComponent,
    PlacaComponent,
    StateCircleComponent,
    CardRotaComponent,
    IconeRotaComponent,
    DetalhesRotaComponent,
    ProgressCircleComponent,
    TimelineComponent,
    ResumoRotaComponent,
    ResumoRotaDialogComponent,
    RelatoriDinamicoXlsDialogComponent,
    HistoricoRotaComponent,
    CardRotaExpansivelComponent,
    CancelarRotaComponent,
    CardStatusIndicadoresComponent,
    DoubleSliderComponent,
    CardResumoComponent,
    RotaDetalhesDialogComponent,
    LogoAppComponent,
    RotaDetalhesResumoComponent,
    RotaDetalhesRelatorioComponent,
    RelatoriDinamicoPdfComponent,
    RelatoriDinamicoXlsComponent,
    RotaDetalhesDocumentosComponent,
    RotaDetalhesRecibosComponent,
    CancelaVisitaComponent,
    EditServiceComponent,
    DialogEditServiceComponent,
    ToolbarFiltroComponent,
    ToolbarFiltroItemComponent,
    CustomTimePickerComponent,
    CabecalhoRotaComponent,
    BotaoObservableComponent,
    ChatComponent,
    ChatRoomListComponent,
    TituloBreadcrumbComponent,
    TabelaServicosComponent,
    RotaCorDialogComponent,
    PieChartComponent,
    DialogCancelarComponent,
    TableCrudHeaderComponent,
    LegendaMaxWidthDirective,
    TableCrudDialogComponent,
    ModalServicosComponent,
    HistoricoRegistrosComponent,
    NotificationComponent,
    CardVisitMapComponent,
    DetalhesTimelineMapComponent,
    TimelineVerticalComponent,
    VisitaDetalhesDrawerComponent,
    GaugeComponent,
    PageHeaderComponent
  ],
  exports: [
    LegendaComponent,
    PlacaComponent,
    StateCircleComponent,
    CardRotaComponent,
    CardRotaExpansivelComponent,
    IconeRotaComponent,
    DetalhesRotaComponent,
    ProgressCircleComponent,
    TimelineComponent,
    ResumoRotaComponent,
    CancelarRotaComponent,
    CardResumoComponent,
    LogoAppComponent,
    RotaDetalhesRelatorioComponent,
    DoubleSliderComponent,
    ToolbarFiltroComponent,
    ToolbarFiltroItemComponent,
    BotaoObservableComponent,
    CabecalhoRotaComponent,
    ChatComponent,
    ChatRoomListComponent,
    TituloBreadcrumbComponent,
    TabelaServicosComponent,
    RotaDetalhesDocumentosComponent,
    RotaDetalhesRecibosComponent,
    TranslateModule,
    PieChartComponent,
    TableCrudHeaderComponent,
    TableCrudDialogComponent,
    HistoricoRegistrosComponent,
    NotificationComponent,
    CardVisitMapComponent,
    DetalhesTimelineMapComponent,
    TimelineVerticalComponent,
    VisitaDetalhesDrawerComponent,
    GaugeComponent,
    PageHeaderComponent
  ],
  imports: [
    CommonModule,
    VisualModule,
    FormsModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    TranslateModule,
    NgChartsModule,
    MatTableModule,
    LucideAngularModule,
    RouterModule,
    PipesModule,
  ],
})
export class ComponentsModule {
}
